import React from 'react';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './Step4Agreement.module.css';

const AGREEMENTS = [
  {
    name: 'buyerAgreementTerms',
    label: 'Global Buyer Terms of Service & Transactional Agreement',
    url: '/terms-of-service',
  },
  {
    name: 'buyerAgreementPrivacy',
    label: 'Privacy & Data Policy (including Information Masking & Anti-Circumvention)',
    url: '/privacy-policy',
  },
  {
    name: 'buyerAgreementRefund',
    label: 'Refund & Dispute Resolution Policy',
    url: '/refund-dispute-policy',
  },
  {
    name: 'buyerAgreementEthics',
    label: 'ChinaDolphins Global Code of Ethics & Social Responsibility',
    url: '/code-of-ethics',
  },
  {
    name: 'buyerAgreementAml',
    label: 'ChinaDolphins Global Trade & AML Compliance Policy',
    url: '/trade-aml-compliance',
  },
];

const BuyerStep4Agreement = ({ nextStep, prevStep, initialValues }) => {
  const validate = values => {
    const errors = {};
    AGREEMENTS.forEach(a => {
      if (!values[a.name]) errors[a.name] = 'You must accept this agreement to continue';
    });
    return errors;
  };

  return (
    <Form
      onSubmit={nextStep}
      validate={validate}
      initialValues={initialValues}
      render={({ handleSubmit, submitFailed, errors }) => (
        <form onSubmit={handleSubmit} className={css.form}>
          <div className={css.header}>
            <span className={css.step}>Step 4 of 5</span>
            <h2 className={css.title}>Platform Agreements &amp; Compliance</h2>
            <p className={css.description}>
              Please read and accept all mandatory agreements to complete your buyer registration.
            </p>
          </div>

          <hr className={css.divider} />

          {submitFailed && Object.keys(errors).length > 0 && (
            <div className={css.submitError}>
              ⚠ Please accept all required agreements before continuing.
            </div>
          )}

          <div className={css.card}>
            {AGREEMENTS.map(agreement => (
              <Field key={agreement.name} name={agreement.name} type="checkbox">
                {({ input, meta }) => (
                  <div className={classNames(css.row, { [css.rowError]: meta.touched && meta.error })}>
                    <div className={css.left}>
                      <input {...input} type="checkbox" />
                      <div>
                        <span>
                          {agreement.label}
                          <span className={css.required}> *</span>
                        </span>
                        {meta.touched && meta.error && (
                          <div className={css.fieldError}>{meta.error}</div>
                        )}
                      </div>
                    </div>
                    <button
                      type="button"
                      className={css.view}
                      onClick={() => window.open(agreement.url, '_blank')}
                    >
                      View
                    </button>
                  </div>
                )}
              </Field>
            ))}
          </div>

          <div className={css.infoBox}>
            <p>
              ✓ By accepting all agreements, you confirm that you are authorised to make commercial
              purchases on behalf of your company and agree to ChinaDolphins commercial terms.
            </p>
          </div>

          <div className={css.buttonContainer}>
            <button type="button" onClick={prevStep} className={css.previous}>← Previous</button>
            <button type="submit" className={css.button}>Next : Review →</button>
          </div>
        </form>
      )}
    />
  );
};

BuyerStep4Agreement.defaultProps = { initialValues: {} };
BuyerStep4Agreement.propTypes = {
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

export default BuyerStep4Agreement;
